// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2dxFT","boxTitle":"Qualiphy_boxTitle__2ajIs","box":"Qualiphy_box__uqwdG","toggleWrap":"Qualiphy_toggleWrap__24lIp"};